<!-- En order-review-dialog.html -->
<div class="dialog-container">
  <header class="dialog-header">
    <mat-icon class="info">edit_note</mat-icon>
    <h2>Instrucciones Especiales</h2>
  </header>

  <mat-dialog-content class="dialog-content">
    <p>Personaliza cada plato antes de enviar el pedido a la cocina.</p>

    <div class="review-list">
      @for (item of cartItems; track item.cartLineItemId) {
        <div class="product-card">
          <div class="product-info">
            <span class="product-quantity">{{ item.quantity }}x</span>
            <span class="product-name">{{ item.name }}</span>
          </div>
          <mat-form-field appearance="fill" class="note-field" style="width: 100%;">
            <mat-label>¿Alguna nota especial?</mat-label>
            <textarea [(ngModel)]="item.notes"
                      matInput
                      placeholder="Ej: Sin cebolla..."
                      rows="2"></textarea>
          </mat-form-field>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="actions-row">
    <button (click)="close()" class="btn-action secondary" mat-flat-button>
      CANCELAR
    </button>
    <button (click)="confirm()" class="btn-action primary" mat-flat-button>
      CONFIRMAR
    </button>
  </mat-dialog-actions>
</div>
